import _ from 'lodash';
import {CORS_PROXY} from './apps_service';

export default class OfficesService {
  constructor(SeldaAPIService, $http, $q) {
    'ngInject';
    Object.assign(this, {SeldaAPIService, $http, $q});
  }

  /**
   * Retrieve list of all offices
   */
  list(id = null) {
    if (!this._memoizedList) {
      // original implementation without cache
      let _list = (id) => {
        let officesP = this.SeldaAPIService.requestService('sediFDM', {sedi: id ? id : ''});
        let namesP = this.officeNames();
        return this.$q.all([officesP, namesP]) // extend returned offices with combined name
          .then(_.spread((offices, names) => _(offices).map((office) => _.extend(office, {label: names[office.id] || office.title}))
            .sortBy((office) => office.id == 100 ? 'AAAAAAAAAA' : office.label.toLowerCase() ).value()));
      };
      // memoize the function
      this._memoizedList = _.memoize(_list);
    }
    // call the memoized function
    return this._memoizedList(id);
  }

  officeNames() {
    return this.$http.get(`${CORS_PROXY}http://www.federmanager.it/wp-json/wp/v2/associazione?per_page=100`)
      .then((offices) => _(offices.data).keyBy((o) => o.id_aplbo * 1).mapValues(_.property('title.rendered')).value());
  }

  /**
   * Returns a single office as a promise
   * @param id
   * @returns {*|Promise.<TResult>}
   */
  getOffice(id) {
    return this.list().then((list) => _(list).find(office => office.id == id));
  }
}


// WEBPACK FOOTER //
// ./client/app/services/offices_service.js